import { render, staticRenderFns } from "./TeacherListCarousel.vue?vue&type=template&id=63546d9a&scoped=true&"
import script from "./TeacherListCarousel.vue?vue&type=script&lang=js&"
export * from "./TeacherListCarousel.vue?vue&type=script&lang=js&"
import style0 from "./TeacherListCarousel.vue?vue&type=style&index=0&id=63546d9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63546d9a",
  null
  
)

export default component.exports